import { Component, Input, TemplateRef, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  @Input() text?: string;
  @Input() template?: TemplateRef<any>;

  @Output() readonly contentChanged = new EventEmitter<void>();
}
